import { axiosInstance } from '@/config/axios.config';
import {
  UnderwearPromotionRequest,
  UnderwearPromotionResponse,
  UpdateUnderwearPromotionRequest,
} from '@repo/types/src/underwear-promotion';

export const getAllUnderwearPromotions = async () => {
  const response = await axiosInstance.get<UnderwearPromotionResponse[]>(
    '/underwear-promotion/admin',
  );
  return response.data;
};

const buildFormData = (
  payload: UnderwearPromotionRequest | UpdateUnderwearPromotionRequest,
) => {
  const formData = new FormData();
  if ('file' in payload && payload.file) formData.append('file', payload.file);
  formData.append('name', payload.name);
  formData.append('description', payload.description);
  formData.append('link', payload.link);
  formData.append('timeStart', String(payload.timeStart));
  formData.append('occurrence', String(payload.occurrence));
  formData.append('nthOpen', String(payload.nthOpen));
  return formData;
};

export const createUnderwearPromotion = async (
  payload: UnderwearPromotionRequest,
) => {
  const response = await axiosInstance.post<UnderwearPromotionResponse>(
    '/underwear-promotion/admin',
    buildFormData(payload),
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return response.data;
};

export const updateUnderwearPromotion = async (
  id: number,
  payload: UpdateUnderwearPromotionRequest,
) => {
  const response = await axiosInstance.patch<UnderwearPromotionResponse>(
    `/underwear-promotion/admin/${id}`,
    buildFormData(payload),
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return response.data;
};

export const deleteUnderwearPromotion = async (id: number) => {
  const response = await axiosInstance.delete<UnderwearPromotionResponse>(
    `/underwear-promotion/admin/${id}`,
  );
  return response.data;
};
